import { Component } from '@angular/core';
import { Platform } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar/';
import { SplashScreen } from '@ionic-native/splash-screen/';
import  firebase  from 'firebase';
//import { AngularFireDatabase } from 'angularfire2/database';
import { HomePage } from '../pages/home/home';
import { FirebaseProvider } from '../providers/firebase/firebase';
//import { AngularFireDatabaseModule } from 'angularfire2/database';
import { AgencyPage } from '../pages/home/agency/agency';
import { AdminPage } from '../pages/home/admin/admin';
import { ContactPage } from '../pages/home/contact/contact';
import { AnnoncePage } from '../pages/home/annonce/annonce';
//import { SellsPage } from '../pages/home/sells/sells';
import { BaremePage } from '../pages/home/bareme/bareme';
import { NosbiensPage } from '../pages/home/nosbiens/nosbiens';
import { PartnerPage } from '../pages/home/partner/partner';
import * as $ from 'jquery';
import { Deeplinks } from '@ionic-native/deeplinks/';
//import { IonicModule } from '@ionic/angular';

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  rootPage:any = 'HomePage';
  x:any;
  y:any;
  prevTouchPosition : { x, y};
  user = firebase.auth().currentUser;

  constructor(platform: Platform, statusBar: StatusBar, splashScreen: SplashScreen,private deeplinks: Deeplinks) {
    
    /*platform.is('android'){
      
    }*/

    
    this.deeplinks.route({
      '/LMImmo': 'HomePage',
      '/NosAgences': 'AgencyPage',
      '/Admin': 'AdminPage',
      '/Profile': 'ProfilePage',
      '/Contact': 'ContactPage',
      '/Annonce': 'AnnoncePage',
      '/Bareme': 'BaremePage',
      '/NosBiens': 'NosbiensPage',
      '/NosPartenaires': 'PartnerPage',
    }).subscribe(match => {
      // match.$route - the route we matched, which is the matched entry from the arguments to route()
      // match.$args - the args passed in the link
      // match.$link - the full link data
      console.log('Successfully matched route', match);
    }, nomatch => {
      // nomatch.$link - the full link data
      console.error('Got a deeplink that didn\'t match', nomatch);
    });
/*

  var prevTouchPosition = {x,y},
  scrollYClass = 'scroll-y',x,y,
  scrollXClass = 'scroll-x',
  scrollClass = 'scroll',
  searchTerms = '.' + scrollYClass + ', .' + scrollXClass + ', .' + scrollClass;



$('body').on('touchstart', (e) => {
 





  var $scroll = $(e.target).closest(searchTerms),
      targetTouch = e.originalEvent.targetTouches[0];
      console.log("TargetTouchstart ",targetTouch, " Scroll : ",$scroll," Scroll Top : ",$scroll.scrollTop());


  // Store previous touch position if within a scroll element
  prevTouchPosition = $scroll.length ? { x: targetTouch.pageX, y: targetTouch.pageY } : x,y;
  
});








$('body').on('touchmove',  (e) => {
var $scroll = $(e.target).closest(searchTerms),
    targetTouch = e.originalEvent.targetTouches[0];
    console.log("TargetTouchmove ",targetTouch," Scroll Top : ",$scroll.scrollTop(), " prevTouch : ", prevTouchPosition," Lenght : ",  $scroll.length)
//if (!$scroll.hasClass(scrollYClass) && !$scroll.hasClass(scrollXClass))  {e.preventDefault();console.log("TOUCH NO SCROLL : ");e.stopPropagation();}
  
if (prevTouchPosition && $scroll.length) {
    // Set move helper and update previous touch position
   
   
    var move = {
      x: targetTouch.pageX - prevTouchPosition.x,
      y: targetTouch.pageY - prevTouchPosition.y
    };
  prevTouchPosition = { x: targetTouch.pageX, y: targetTouch.pageY };
  console.log("Prev Touch Position : ",  prevTouchPosition)
    // Check for scroll-y or scroll-x classes
    if ($scroll.hasClass(scrollYClass)) {
      console.log("Scroll Y ",$scroll.hasClass(scrollYClass))
        var scrollHeight = $scroll[0].scrollHeight,
            outerHeight = $scroll.outerHeight(),
            
            atUpperLimit = ($scroll.scrollTop() === 0),
            atLowerLimit = (scrollHeight - $scroll.scrollTop() === outerHeight);

        console.log("SCROLL Limit, Height :  ", scrollHeight," OuterHeight : ", outerHeight, " Move X : ",move.x, " Move Y : ", move.y)
        if (scrollHeight > outerHeight) {
          console.log("Test Limite");
          if ($scroll.scrollTop() < 1) {     //TEST LIMITE PERSO
            console.log("ON DESCEND DE 1")
            $scroll.scrollTop(2);
            e.stopPropagation();
            console.log("DESCENDU YSCROLL",$scroll[0].scrollHeight,$scroll[0].clientHeight,$scroll.outerHeight(),$scroll.scrollTop())
          } else if(($scroll[0].scrollHeight - $scroll.scrollTop()) - $scroll.outerHeight()< 1) {
          // If we're at the bottom, scroll up one pixel to allow scrolling down
          //if (($scroll[0].scrollHeight - $scroll.scrollTop()) - $scroll.outerHeight()< 2) {
            console.log("ON REMONTE DE 1")
            //$scroll.scrollTop($scroll.scrollTop() - 1);
            $scroll.scrollTop($scroll[0].scrollHeight - $scroll[0].clientHeight - 2);
            e.stopPropagation();
            console.log("REMONTE YSCROLL",$scroll[0].scrollHeight,$scroll[0].clientHeight,$scroll.outerHeight(),$scroll.scrollTop(),$scroll.outerHeight() - $scroll[0].scrollHeight - $scroll.scrollTop())
          }else{
           
            console.log("scrolly normal",e.isDefaultPrevented)
          }
        
        
          if(Math.abs(move.x) > 0 && Math.abs(move.y) < 3){
            console.log("PREVENT BAD MOVE")
            e.preventDefault()
          }
          
        
        
        }else {
          console.log("SCROLL Limit height=outerheight")
            //e.stopPropagation();
            // No scrolling / adjustment when there is nothing to scroll
            e.preventDefault();
        }
    
    }
} else {
  console.log("Non Scroll Element")
    // Prevent scrolling on non-scrolling elements
    e.preventDefault();
    e.stopPropagation();
}
console.log("Event end")
});


  */



  // Enable native scrolls for Android platform only,
  // as you see, we're disabling jsScrolling to achieve this.
  




    platform.ready().then(() => {
      
    
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      statusBar.styleDefault();
      splashScreen.hide();
    });
  }




  
}




// WEBPACK FOOTER //
// ./src/app/app.component.ts